import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Amenities = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="amenities">
      <span className="section-link"></span>{" "}
      <div className="row">
        <div className="col-md-8">
          <h2 className="head text-capitalize">
            Sheth Younique Sion - Amenities
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale float-lg-right mx-sm-auto  d-none d-lg-block"
            onClick={handleShowModal}
          >
            Download Amenities
          </button>
        </div>
      </div>
      <div className="owl-carousel-img owl-carousel owl-theme gallery-img">
        <div data-fancybox="gallery-0" onClick={handleShowModal}>
          {" "}
          <div>
            <img
              data-src="../images/sheth-promont-aminity1.webp"
              loading="lazy"
              className="gallery-thumb ls-is-cached lazyloaded"
              src="images/sheth-promont-aminity1.webp"
              alt="logo"
            />
          </div>
        </div>

        <div data-fancybox="gallery-0" onClick={handleShowModal}>
          <div>
            <img
              data-src="../images/sheth-promont-aminity2.webp"
              loading="lazy"
              className="gallery-thumb ls-is-cached lazyloaded"
              src="images/sheth-promont-aminity2.webp"
              alt="logo"
            />
          </div>
        </div>
        <div data-fancybox="gallery-0" onClick={handleShowModal}>
          {" "}
          <div>
            <img
              data-src="../images/sheth-promont-aminity3.webp"
              loading="lazy"
              className="gallery-thumb ls-is-cached lazyloaded"
              src="images/sheth-promont-aminity3.webp"
              alt="logo"
            />
          </div>
        </div>
        <div data-fancybox="gallery-0" onClick={handleShowModal}>
          {" "}
          <div>
            <img
              data-src="../images/sheth-promont-aminity4.webp"
              loading="lazy"
              className="gallery-thumb ls-is-cached lazyloaded"
              src="images/sheth-promont-aminity4.webp"
              alt="logo"
            />
          </div>
        </div>
      </div>
      <div className="col-12">
        <button
          className="chat-btn btn btn-info micro-form-btn enqModal effetMoveGradient effectScale float-lg-right mx-sm-auto d-lg-none"
          data-form="lg"
          data-title="Download Gallery"
          data-btn="Send Now"
          data-enquiry="Download Gallery"
          data-redirect="floorplan"
          data-toggle="modal"
          data-target="#enqModal"
          onClick={handleShowModal}
        >
          Download Amenity
        </button>
      </div>
    </section>
  );
};

export default Amenities;
